import React, { useEffect, useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { experimentService, ExperimentSlim } from 'src/services';
import { useAppSelector } from 'src/hooks';
import { Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import { AbTestDashboard } from 'src/components-bl';
import { experimentRoutes } from 'src/app-routes';

export const AbTestDashboardContainer = (): JSX.Element | null => {
  const shopId = useAppSelector(state => state.shop.current?.shopId);
  const history = useHistory();
  const { experimentId } = useParams<{ experimentId: string }>();
  const [experiment, setExperiment] = useState<ExperimentSlim | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shopId || !experimentId) return undefined;

    let cancelled = false;

    setLoading(true);
    setError(null);

    experimentService
      .getExperiment({ shopId, id: experimentId, slim: true })
      .then(result => {
        if (cancelled) return;
        setExperiment(result as ExperimentSlim);
      })
      .catch(() => {
        if (cancelled) return;
        setError('Failed to load experiment. Please try again.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [shopId, experimentId]);

  const onBack = (): void => {
    if (!shopId) return;
    history.push(generatePath(experimentRoutes.experiments.path, { shopId }));
  };

  if (!shopId) return null;

  if (loading) {
    return (
      <Typography type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
        Loading…
      </Typography>
    );
  }

  if (error || !experiment) {
    return (
      <Typography type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
        {error ?? 'Experiment not found.'}
      </Typography>
    );
  }

  return (
    <AbTestDashboard
      shopId={shopId}
      experimentId={experimentId}
      experiment={experiment}
      onBack={onBack}
    />
  );
};
